import axios from "axios";
import { URL_BASE } from "./0_url_base";

//const URL = 'http://localhost:3001/filiado';
const URL = URL_BASE + '/filiado';

const filiadoAPI = axios.create({
    baseURL: URL,
    headers: {
        Accept: 'application/json',
        Content: 'application/json'
    }
})

filiadoAPI.interceptors.request.use(function (config) {
    const Token = sessionStorage.getItem('token');
    if((Token) && (config.headers)){
        config.headers.Authorization = `Bearer ${Token}`
    }
    return config;
}, function (error) {
    console.log("Erro na API de Filiados");
    return Promise.reject(error);
});


filiadoAPI.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return Promise.reject(error);
});


export {
    filiadoAPI
};